"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SheetSection = exports.SheetRow = exports.SheetHeader = exports.SheetFooter = exports.Sheet = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "className", "containerElement"],
  _excluded2 = ["children", "className", "containerElement"],
  _excluded3 = ["children", "className", "containerElement"],
  _excluded4 = ["children", "className", "containerElement"],
  _excluded5 = ["children", "className", "containerElement", "size"];
/**
 * SPDX-FileCopyrightText: © 2020 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var SheetHeader = exports.SheetHeader = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$containerElement = _ref.containerElement,
    ContainerElement = _ref$containerElement === void 0 ? 'div' : _ref$containerElement,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'sheet-header'),
    ref: ref
  }), children);
});
SheetHeader.displayName = 'ClaySheetHeader';
var SheetFooter = exports.SheetFooter = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    className = _ref2.className,
    _ref2$containerElemen = _ref2.containerElement,
    ContainerElement = _ref2$containerElemen === void 0 ? 'div' : _ref2$containerElemen,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'sheet-footer'),
    ref: ref
  }), children);
});
SheetFooter.displayName = 'ClaySheetFooter';
var SheetSection = exports.SheetSection = /*#__PURE__*/_react.default.forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
    className = _ref3.className,
    _ref3$containerElemen = _ref3.containerElement,
    ContainerElement = _ref3$containerElemen === void 0 ? 'div' : _ref3$containerElemen,
    otherProps = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'sheet-section'),
    ref: ref
  }), children);
});
SheetSection.displayName = 'ClaySheetSection';
var SheetRow = exports.SheetRow = /*#__PURE__*/_react.default.forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
    className = _ref4.className,
    _ref4$containerElemen = _ref4.containerElement,
    ContainerElement = _ref4$containerElemen === void 0 ? 'div' : _ref4$containerElemen,
    otherProps = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'sheet-row'),
    ref: ref
  }), children);
});
SheetRow.displayName = 'ClaySheetRow';
var Sheet = exports.Sheet = /*#__PURE__*/_react.default.forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
    className = _ref5.className,
    _ref5$containerElemen = _ref5.containerElement,
    ContainerElement = _ref5$containerElemen === void 0 ? 'div' : _ref5$containerElemen,
    size = _ref5.size,
    otherProps = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react.default.createElement(ContainerElement, _extends({}, otherProps, {
    className: (0, _classnames.default)(className, 'sheet', _defineProperty({}, "sheet-".concat(size), size)),
    ref: ref
  }), children);
});
Sheet.displayName = 'ClaySheet';